// create wrapper that creates a default instance of ImmersiveData to make it
// simpler to import and use.

import ImmersiveData from './src/ImmersiveData.js'
import * as streamUtil from './src/streamUtil.js'
const {facadeStreamSetter, useStateStream} = streamUtil

export {streamUtil, ImmersiveData}

export const immersiveData = new ImmersiveData()

export default immersiveData

export const authorizationSetter = facadeStreamSetter.bind(null, immersiveData.authStreamOutput)
export const useAuthorizationStream = useStateStream.bind(null, immersiveData.authStreamOutput)

export const platformApi = immersiveData.platformApi

export const investigationListStream = immersiveData.investigationListStream
export const investigationListSetter = facadeStreamSetter.bind(null, investigationListStream)
export const useinvestigationList = useStateStream.bind(null, investigationListStream)

export const investigationRecorder = immersiveData.investigationRecorder

export const domainObjects = immersiveData.domainObjects
export const getDomainObjectStream = domainObjects.getStream.bind(domainObjects)
export const domainObjectSetter = domainObjects.getSetter.bind(domainObjects)
export const useDomainObject = domainObjects.useHook.bind(domainObjects)

export * from './src/Actions.js'
